const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
let BACKEND_URL = '';

if (!ENV_BACKEND_URL || ENV_BACKEND_URL === '') {
  BACKEND_URL = window.location.origin;
} else {
  BACKEND_URL = ENV_BACKEND_URL;
}

if (BACKEND_URL.endsWith('/api')) {
  BACKEND_URL = BACKEND_URL.slice(0, -4);
}

const API = `${BACKEND_URL}/api`;
export default API;
